var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"placePicker"},[_c('van-popup',{attrs:{"position":"bottom"},model:{value:(_vm.showPlacePicker),callback:function ($$v) {_vm.showPlacePicker=$$v},expression:"showPlacePicker"}},[_c('van-area',{attrs:{"area-list":_vm.areaList,"value":_vm.value},on:{"confirm":_vm.confirm,"cancel":function($event){_vm.modelClose=false}}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }